
function setAllPageWidths() {
  var adMedia = document.getElementsByClassName('page-ad-media');
  for(var i = 0; i < adMedia.length; i++){
    adMedia[i].style.width = ((adMedia[i].offsetWidth / window.innerWidth) * 100) + 'vw';
    adMedia[i].style.maxWidth='none';
  }
}

// Vanilla JS Modal functionality
function showVanillaModal(modalElement, options = {}) {
	const defaults = {
		closeOnBackdrop: true,
		closeOnEscape: true,
		showClose: true,
		fadeIn: true,
		onClose: null
	};
	
	const settings = Object.assign({}, defaults, options);
	
	// Create blocker/backdrop
	const blocker = document.createElement('div');
	blocker.className = 'blocker jquery-modal current';
	blocker.style.cssText = `
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		z-index: 1000;
		display: flex;
		align-items: center;
		justify-content: center;
		opacity: 0;
		transition: opacity 0.3s ease;
	`;
	
	// Style the modal
	modalElement.style.cssText = `
		position: relative;
		background: white;
		border-radius: 8px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
		max-width: 90vw;
		max-height: 90vh;
		min-width: 300px;
		overflow: auto;
		margin: 20px;
		opacity: 0;
		transform: scale(0.8);
		transition: all 0.3s ease;
	`;
	
	// Add modal class if not present
	if (!modalElement.classList.contains('modal')) {
		modalElement.classList.add('modal');
	}
	
	// Add close button if requested
	if (settings.showClose) {
		const closeBtn = document.createElement('a');
		closeBtn.href = '#';
		closeBtn.className = 'close-modal';
		closeBtn.innerHTML = '×';
		closeBtn.style.cssText = `
			position: absolute;
			top: 10px;
			right: 15px;
			font-size: 24px;
			font-weight: bold;
			text-decoration: none;
			color: #999;
			z-index: 1001;
			line-height: 1;
		`;
		modalElement.appendChild(closeBtn);
	}
	
	// Append to blocker and show
	blocker.appendChild(modalElement);
	document.body.appendChild(blocker);
	
	// Trigger show animation
	setTimeout(() => {
		blocker.style.opacity = '1';
		modalElement.style.opacity = '1';
		modalElement.style.transform = 'scale(1)';
	}, 10);
	
	// Close function
	const closeModal = () => {
		blocker.style.opacity = '0';
		modalElement.style.opacity = '0';
		modalElement.style.transform = 'scale(0.8)';
		
		setTimeout(() => {
			if (blocker.parentNode) {
				blocker.parentNode.removeChild(blocker);
			}
			if (settings.onClose) {
				settings.onClose();
			}
		}, 300);
	};
	
	// Event handlers
	if (settings.closeOnBackdrop) {
		blocker.addEventListener('click', (e) => {
			if (e.target === blocker) {
				closeModal();
			}
		});
	}
	
	if (settings.closeOnEscape) {
		const escapeHandler = (e) => {
			if (e.key === 'Escape') {
				closeModal();
				document.removeEventListener('keydown', escapeHandler);
			}
		};
		document.addEventListener('keydown', escapeHandler);
	}
	
	// Close button click
	modalElement.addEventListener('click', (e) => {
		if (e.target.matches('.close-modal') || e.target.closest('.close-modal')) {
			e.preventDefault();
			closeModal();
		}
	});
	
	// Return close function for external use
	return closeModal;
}

document.addEventListener('DOMContentLoaded', function () {
	
	//Initiate ad carousel interactions
	var adCarousel = new AdCarousel();
	adCarousel.init();

	//Link click areas
	var linkAreas = new LinkAreas();
	linkAreas.init();

	//Overlay for mobile scrolling instructions
	var scrollverlay = new Scrollverlay();
	scrollverlay.init();

});

class LinkAreas {
	constructor() {
		//Get all our object scoped elements and params
		this.carouselElem = document.getElementsByClassName('specialContainer')[0];
	}
	
	init = function(){
		this.handleEvents();
		//Briefly show click areas on load
		this.showLinkAreas();
	}

	handleEvents = function() {
		let self = this;
		//Link area click
		const quickviewLinks = document.querySelectorAll('.specialContainer .linkArea.hasQuickview a');
		quickviewLinks.forEach(function(link) {
			link.addEventListener('click', function(e) {
				e.preventDefault();
				const linkArea = link.closest('.linkArea');
				self.showQuickView(link.dataset.type, link.dataset.quickview, linkArea);
			});
		});
		//Add to cart click
		
	}

	showQuickView = function(type, quickViewId, linkArea) {
		//Get overlay data
		const params = new URLSearchParams({
			action: 'linkAreaQuickview',
			type: type,
			quickViewId: quickViewId
		});
		
		fetch(globalObject.url + 'ajax/specials.php?' + params.toString(), {
			method: 'GET'
		})
		.then(response => response.text())
		.then(response => {
			if(response) {
				
				//Append quickview modal to link area
				linkArea.insertAdjacentHTML('beforeend', response);

				//Init product image swiper
				initializeProductPageSwipers();
				//Hide thumb images
				const swiperThumbImages = document.querySelector('.swiper-thumb-images');
				if (swiperThumbImages) {
					swiperThumbImages.style.display = 'none';
				}

				//Initiate add to cart functions
				var addToCart = new AddToCart();
				addToCart.init();

				//Initiate mattress sizes functions
				var mattressSizes = new MattressSizes();
				mattressSizes.init();

				//Show modal
				let modal = linkArea.querySelector('.modal');
				if (modal) {
					showVanillaModal(modal, {
						onClose: function() {
							//Remove existing modal
							modal.remove();
						}
					});
				}

			}
		})
		.catch(error => {
			console.error('Error loading quickview:', error);
		});
	}

	showLinkAreas = function() {
		const linkAreas = document.querySelectorAll('.specialContainer .linkArea');
		linkAreas.forEach(linkArea => {
			linkArea.classList.add('hover');
		});
		setTimeout(function(){
			linkAreas.forEach(linkArea => {
				linkArea.classList.remove('hover');
			});
		}, 2000);
	}

}

class AdCarousel {
	constructor() {
		//Get all our object scoped elements and params
		this.carouselElem = document.getElementsByClassName('specialContainer')[0];
		this.carouselView = this.carouselElem.getElementsByClassName('specialsViewer')[0];
		this.carouselList = this.carouselElem.getElementsByClassName('specials-page-list')[0];
		this.paginationContainer = document.getElementsByClassName('pagination')[0];
		this.zoomControl = this.carouselElem.getElementsByClassName('zoom')[0];
		this.zoomInBtn = this.zoomControl.getElementsByClassName('zoom-in');
		this.zoomOutBtn = this.zoomControl.getElementsByClassName('zoom-out');
		this.prevPageBtn = this.carouselElem.getElementsByClassName('prev')[0];
		this.nextPageBtn = this.carouselElem.getElementsByClassName('next')[0];
		this.mobileNav = document.getElementsByClassName('mobile-nav')[0];
		this.isFlipBook = this.carouselElem.classList.contains('page-flip');
		this.trigger = false;
	}

	init = function(){
		let self = this;
		//Check if page flip class is loaded. If not, attempt to load again
		if(this.isFlipBook) {
			showLoadingOverlay();
			//Check if all images are loaded
			let imgLoad = setInterval(function () {
				let imagesLoaded = 0;
				let pages = self.carouselList.getElementsByClassName('page');
				for(let i = 0; i < pages.length; i++){
					let img = pages[i].getElementsByClassName('page-ad-media')[0];
					if(img) {
						if(img.naturalWidth) {
							imagesLoaded++;
							if(imagesLoaded == pages.length - 1) { //Account for ending page
								clearInterval(imgLoad);
								let pageFlipTest = setInterval(function(){
									if(typeof St !== 'undefined') {
										clearInterval(pageFlipTest);
										hideLoadingOverlay();
										self.initFlipBook();
									}
								}, 100);
							}
						}
					}
				}
			}, 10);
		}

		this.positionControls();
		this.addScrollEventHandler();
		this.addResizeEventHandler();
		this.paginationHandler();
		this.zoomHandler();
	}

	initFlipBook = function() {
		//Initiate flip book
		if(this.isFlipBook) {
			let bookWidth = 0,
				bookHeight = 0,
				inconsistentSizes = false;
			//Find tallest image in list
			let pages = this.carouselList.getElementsByClassName('page');
			for(let i = 0; i < pages.length; i++){
				let img = pages[i].getElementsByClassName('page-ad-media')[0];
				if(img) {
					//Check if images are inconsistent heights
					let prevImg = i > 0 ? pages[i-1].getElementsByClassName('page-ad-media')[0] : '';
					if(prevImg && prevImg.naturalHeight != img.naturalHeight) {
						inconsistentSizes = true;
					}
					//Set book height taller if image is taller
					if(img.naturalHeight > bookHeight) {
						bookHeight = img.naturalHeight;
					}
					//Set book width wider if image is wider
					if(img.naturalWidth > bookWidth) {
						bookWidth = img.naturalWidth;
					}
				}
			}
			//Only allow flip book functionality if all images are the same height
			if(inconsistentSizes == true) {
				//Images are inconsistent, remove page flip functionality
				this.carouselElem.classList.remove("page-flip");
				this.isFlipBook = false;
			} else {
				//Initiate page flip
				this.pageFlip = new St.PageFlip(
					this.carouselList, {
						width: bookWidth, // base page width
						height: bookHeight > 0 ? bookHeight : 2000, // base page height
						size: "stretch",
						minWidth: 315,
						maxWidth: 1000,
						minHeight: 420,
						maxHeight: 1350,
						maxShadowOpacity: 0.5, // Half shadow intensity
						showCover: true,
						mobileScrollSupport: true // disable content scrolling on mobile devices
					}
				);
				//Load pages
				this.pageFlip.loadFromHTML(this.carouselList.querySelectorAll("li.page"));
				const signupInputs = document.querySelectorAll('.specialsSignup input');
				signupInputs.forEach(input => {
					input.addEventListener('click', function() {
						this.focus();
					});
				});
			}
		}
	}

	middleAlignControls = function(){
		let boundingBox = this.carouselElem.getBoundingClientRect();
		//Update zoom controls
		this.zoomControl.style.position = 'fixed';
		this.zoomControl.style.top = '50px';
		this.zoomControl.style.left = (parseInt(boundingBox.left) + parseInt(boundingBox.width)) - 45 + 'px';
		//Update next/prev buttons
		this.prevPageBtn.style.position = 'fixed';
		this.prevPageBtn.style.top = '50vh';
		this.prevPageBtn.style.left = parseInt(boundingBox.left) + 5 + 'px';
		this.nextPageBtn.style.position = 'fixed';
		this.nextPageBtn.style.top = '50vh';
		this.nextPageBtn.style.left = (parseInt(boundingBox.left) + parseInt(boundingBox.width)) - 65 + 'px';

		this.trigger = true; // setting this because we only need to run this once
	}

	topAlignControls = function(top,winHeight) {
		let boundingBox = this.carouselElem.getBoundingClientRect();
		var btnTopPosA = top + (winHeight / 2);
		//Update zoom controls
		this.zoomControl.style.position = 'fixed';
		this.zoomControl.style.top = (boundingBox.top + 50) + 'px';
		this.zoomControl.style.left = (parseInt(boundingBox.left) + parseInt(boundingBox.width)) - 45 + 'px';
		//Update next/prev buttons
		this.prevPageBtn.style.position = 'fixed';
		this.prevPageBtn.style.top = btnTopPosA + 'px';
		this.prevPageBtn.style.left = parseInt(boundingBox.left) + 5 + 'px';
		this.nextPageBtn.style.position = 'fixed';
		this.nextPageBtn.style.top = btnTopPosA + 'px';
		this.nextPageBtn.style.left = (parseInt(boundingBox.left) + parseInt(boundingBox.width)) - 65 + 'px';

		this.trigger = false; // Need to set trigger because we only are using it when checking for 100vh carousel
	}

	bottomAlignControls = function(bottom,winHeight){
		let boundingBox = this.carouselElem.getBoundingClientRect();
		var btnTopPosB = bottom - (winHeight / 2);
		//Update zoom controls
		this.zoomControl.style.position = 'fixed';
		this.zoomControl.style.top = '50px';
		this.zoomControl.style.left = (parseInt(boundingBox.left) + parseInt(boundingBox.width)) - 45 + 'px';
		//Update next/prev buttons
		this.prevPageBtn.style.position = 'fixed';
		this.prevPageBtn.style.top = btnTopPosB + 'px';
		this.prevPageBtn.style.left = parseInt(boundingBox.left) + 5 + 'px';
		this.nextPageBtn.style.position = 'fixed';
		this.nextPageBtn.style.top = btnTopPosB + 'px';
		this.nextPageBtn.style.left = (parseInt(boundingBox.left) + parseInt(boundingBox.width)) - 65 + 'px';

		this.trigger = false; // Need to set trigger because we only are using it when checking for 100vh carousel
	}

	positionControls = function(){
		let boundingBox = this.carouselElem.getBoundingClientRect(),
			windowHeight = window.innerHeight,
			carouselTop = boundingBox.top,
			carouselBottom = boundingBox.bottom;
		// check if carousel is at least 100vh && check the trigger because we only need to run once
		if((carouselTop < 0 && carouselBottom > windowHeight) && this.trigger === false) {
			this.middleAlignControls();
		} else {
			// check for space above ad. Not checking for trigger because the controls move with carousel
			if(carouselTop > 0) {
				this.topAlignControls(carouselTop,windowHeight);
			}
			// check for space below ad. Not checking for trigger because the controls move with carousel
			if(carouselTop < 0 && carouselBottom < windowHeight) {
				this.bottomAlignControls(carouselBottom,windowHeight);
			}
		}
	}

	addScrollEventHandler = function(){
		// No ES6 support in this app "() => {}". So, we need to set a reference to parent object because "this" refers the event in an event	handler.
		let self = this;
		//Listen for scroll on window
		window.addEventListener('scroll',function(event){
			//Position controls
			self.positionControls();

			//Determine to show/hide pagination buttons
			self.activatePaginationControls();
		});
		//Listen for scroll on carousel list
		this.carouselList.addEventListener('scroll',function(event){
			self.updateCurrentPage('');
		});
	}

	addResizeEventHandler = function(){
		let self = this;
		window.addEventListener('resize',function(event){
			//Position controls
			self.trigger = false;
			self.positionControls();

			//Determine to show/hide pagination buttons
			self.activatePaginationControls();
		});
	}

	paginationHandler = function(){
		let self = this;

		//Determine to show/hide pagination buttons
		this.activatePaginationControls();

		//Scroll through ad
		this.nextPageBtn.addEventListener('click', function(){
			self.paginate('next', 'default', true);
		});
		//Scroll through ad
		this.prevPageBtn.addEventListener('click', function(){
			self.paginate('prev', 'default', true);
		});
	}

	paginate = function(direction, pageIncrement, animate) {
		let self = this;

		if(this.isFlipBook) {

			//Paginate with page flip controls
			switch(direction) {
				case 'next':
					this.pageFlip.flipNext();
				break;
				case 'prev':
					this.pageFlip.flipPrev();
				break;
			}

			//Set current pages
			this.updateCurrentPage(direction);
			
			//Determine to show/hide pagination buttons
			self.activatePaginationControls();

		} else {

			//Default functionality
			const carouselViewRect = this.carouselView.getBoundingClientRect();
			const increment = pageIncrement == 'default' ? (carouselViewRect.width / 2) - 10 - 80 : pageIncrement; //Half carousel width - margin
			const leftPos = this.carouselView.scrollLeft;
			let newPos = 0;
			switch(direction) {
				case 'next':
					newPos = leftPos ? leftPos + increment : increment;
				break;
				case 'prev':
					newPos = leftPos && (leftPos - increment) > 0 ? leftPos - increment : 0;
				break;
			}

			//Update position
			this.carouselList.dataset.left = newPos;
			if(animate) {
				//Animate pagination
				this.carouselView.scrollTo({
					left: newPos,
					behavior: 'smooth'
				});
				//Add callback for when animation completes
				setTimeout(() => {
					self.activatePaginationControls();
				}, 200);
			} else {
				//Don't animate pagination
				this.carouselView.scrollLeft = newPos;
				//Determine to show/hide pagination buttons
				self.activatePaginationControls();
			}

			//Set current pages
			this.updateCurrentPage(direction);

		}
	}

	activatePaginationControls = function() {
		
		if(this.isFlipBook) {

			//Disable previous button if at beginning
			let currentPage = this.paginationContainer.getElementsByClassName('current')[0].innerHTML,
				totalPages = this.paginationContainer.getElementsByClassName('total')[0].innerHTML;
			if(currentPage == 1) {
				//Disable prev button
				this.prevPageBtn.disabled = true;
				this.nextPageBtn.disabled = false;
			} else {
				//Enable prev button
				this.prevPageBtn.disabled = false;
				//Check if next button should display
				if(currentPage == totalPages) {
					this.nextPageBtn.disabled = true;
				} else {
					//Re-enable next button
					this.nextPageBtn.disabled = false;
				}
			}

		} else {

			//Disable previous button if at beginning
			let leftPos = this.carouselList.dataset.left ? parseInt(this.carouselList.dataset.left) : 0;
			if(leftPos == 0) {
				//Disable prev button
				this.prevPageBtn.disabled = true;
				this.nextPageBtn.disabled = false;
			} else {
				//Enable prev button
				this.prevPageBtn.disabled = false;
				//Check if next button should display
				let lastPage = this.carouselList.querySelector('li.page:last-child');
				if(this.isScrolledIntoView(lastPage, 'container', 'full')) {
					this.nextPageBtn.disabled = true;
				} else {
					//Re-enable next button
					this.nextPageBtn.disabled = false;
				}
			}
		}
		
	}

	updateCurrentPage = function(direction) {
		let self = this;

		if(this.isFlipBook) {

			//Indicate current page
			let currentPageIndex = this.pageFlip.getCurrentPageIndex() + 1;
			let currentPage = direction == 'prev' ? currentPageIndex - 1 : currentPageIndex + 1;
			this.paginationContainer.getElementsByClassName('current')[0].innerText = currentPage;

			//Indicate total pages
			this.paginationContainer.getElementsByClassName('total')[0].innerText = this.pageFlip.getPageCount();

		} else {

			//Set active pages
			const listItems = this.carouselList.querySelectorAll('li');
			listItems.forEach(item => {
				item.classList.remove('active');
			});
			listItems.forEach(item => {
				if(self.isScrolledIntoView(item, 'container', 'partial')) {
					item.classList.add('active');
				}
			});
			//Indicate what page user is currently viewing
			const activeItems = this.carouselList.querySelectorAll('li.active');
			if(activeItems.length > 0) {
				const lastActiveItem = activeItems[activeItems.length - 1];
				const lastActivePage = Array.from(this.carouselList.querySelectorAll('li')).indexOf(lastActiveItem);
				const currentPage = direction == 'prev' ? lastActivePage : lastActivePage + 1;
				const totalPages = parseInt(this.paginationContainer.getElementsByClassName('total')[0].innerHTML);
				if(currentPage <= totalPages) {
					this.paginationContainer.getElementsByClassName('current')[0].textContent = currentPage;
				}
			}

		}
	}

	isScrolledIntoView = function(elem, viewElem, type) {
		let viewLeft = 0, viewRight = 0;
		switch(viewElem) {
			case 'window':
				viewLeft = 0;
				viewRight = viewLeft + window.innerWidth;
			break;
			case 'container':
				const carouselRect = this.carouselElem.getBoundingClientRect();
				viewLeft = (window.innerWidth - carouselRect.width) / 2;
				viewRight = viewLeft + carouselRect.width;
			break;
		}
	
		const elemRect = elem.getBoundingClientRect();
		const elemLeft = elemRect.left;
		const elemRight = elemLeft + elemRect.width;

		let result = false;
		switch(type) {
			case 'full':
				result = (elemLeft <= viewLeft && elemRight >= viewRight) || (elemLeft >= viewLeft && elemRight <= viewRight);
			break;
			case 'partial':
				result = ((elemLeft <= viewLeft || elemLeft <= viewRight) && (elemRight >= viewLeft || elemRight >= viewRight)) || (elemLeft >= viewLeft && elemLeft <= viewRight && (elemRight >= viewLeft || elemRight >= viewRight));
			break;
		}
		return result;
	}

	zoomHandler = function() {
		let self = this;

		//Set zoom controls
		this.activateZoomControls(1, 2, 'out');

		//Zoom in
		if(this.zoomInBtn.length > 0) {
			this.zoomInBtn[0].addEventListener('click', function(){
				self.zoom('in');
			});
		}
		//Zoom out
		if(this.zoomOutBtn.length > 0) {
			this.zoomOutBtn[0].addEventListener('click', function(){
				self.zoom('out');
			});
		}
	}

	zoom = function(direction) {
		const increment = .3;
		const maxZoom = 2;
		let zoom = this.carouselList.dataset.zoom ? parseFloat(this.carouselList.dataset.zoom) : 1;
		let futureZoom = 0;
		
		switch(direction) {
			case 'in':
				zoom = zoom + increment;
				futureZoom = zoom + increment;
			break;
			case 'out':
				zoom = zoom - increment;
				futureZoom = zoom;
			break;
		}

		//Make sure zoom stays within threshold
		if(zoom < maxZoom && zoom >= 0) {

			//Apply new zoom value & update page widths
			this.carouselList.dataset.zoom = zoom;
			let totalWidth, totalNewWidth;
			totalWidth = totalNewWidth = 0;
			let pages = this.carouselList.getElementsByClassName('page');
			for(let i = 0; i < pages.length; i++){
				let img = pages[i].getElementsByClassName('page-ad-media');
				if(img.length) {
					//Determine new page width
					let pageWidth = Math.round(img[0].getBoundingClientRect().width);
					let newWidth = '1400px';
					switch(direction) {
						case 'in':
							newWidth = Math.round(pageWidth * (increment + 1));
						break;
						case 'out':
							newWidth = Math.round(pageWidth / (increment + 1));
						break;
					}
					//Set new page width
					img[0].style.width = newWidth + 'px';
					img[0].style.maxWidth = 'none';

					//Get totals
					totalWidth += pageWidth;
					totalNewWidth += newWidth;
					
				}
			}

			//Get amount for scroll positioning
			let scrollPos = Math.abs(Math.round(totalNewWidth / pages.length) - Math.round(totalWidth / pages.length));
			
			//Scroll to area where user left off
			let carouselListLeftPos = parseInt(this.carouselList.dataset.left) ? parseInt(this.carouselList.dataset.left) : 0;
			let paginateDirection = '';
			let paginateIncrement = (carouselListLeftPos / 4) + (scrollPos / 2) + 40;
			switch(direction) {
				case 'in':
					paginateDirection = 'next';
					paginateIncrement = paginateIncrement;
				break;
				case 'out':
					paginateDirection = 'prev';
					paginateIncrement = Math.round(paginateIncrement / (increment + 1));
				break;
			}

			//Paginate based on width & left position
			this.paginate(paginateDirection, paginateIncrement, false);

			//Indicate if viewer is zoomed
			if(zoom > 1) {
				this.carouselList.classList.add('zoomed');
			} else {
				this.carouselList.classList.remove('zoomed');
			}

			//Disable zoom buttons accordingly
			this.activateZoomControls(futureZoom, maxZoom, direction);

		} else {

			//Disable zoom buttons accordingly
			this.activateZoomControls(zoom, maxZoom, direction);

		}

		//Reset pagination controls
		this.activatePaginationControls();
	}

	activateZoomControls = function(zoom, maxZoom, direction) {
		//Determine when to enable/disable zoom buttons
		if(zoom >= maxZoom && direction == 'in') {
			//Zooming in
			if(this.zoomInBtn.length > 0) this.zoomInBtn[0].disabled = true;
			if(this.zoomOutBtn.length > 0) this.zoomOutBtn[0].disabled = false;
		} else if(zoom <= 0 && direction == 'out') {
			//Zooming out
			if(this.zoomInBtn.length > 0) this.zoomInBtn[0].disabled = false;
			if(this.zoomOutBtn.length > 0) this.zoomOutBtn[0].disabled = true;
		} else {
			//Enable all zoom buttons
			if(this.zoomInBtn.length > 0) this.zoomInBtn[0].disabled = false;
			if(this.zoomOutBtn.length > 0) this.zoomOutBtn[0].disabled = false;
		}
	}

}

function Scrollverlay() {
	//Get all our object scoped elements and params
	this.container = document.querySelector('.scrollverlay');
	this.gotItButton = this.container ? this.container.querySelector('button.got-it') : null;
		
	this.init = function(){
		this.handleEvents();

		//If not mobile browser & hide swipe isn't set, don't show scrollverlay
		if(document.body.classList.contains('mobile') && getCookie('hide_swipe') != 1) {
			this.showScrollverlay();
		}
	},

	this.handleEvents = function() {
		let self = this;

		if(this.container) {
			this.container.addEventListener("touchstart", function(){
				self.hideScrollverlay();
			});
		}
		if(this.gotItButton) {
			this.gotItButton.addEventListener("click", function(){
				self.hideScrollverlay();
			});
		}
	},

	this.hideScrollverlay = function() {
		if(this.container) {
			this.container.style.opacity = '0';
			this.container.style.transition = 'opacity 0.3s ease';
			setTimeout(() => {
				this.container.style.display = 'none';
			}, 300);
			setCookie('hide_swipe','1',365);
		}
	}

	this.showScrollverlay = function() {
		if(this.container) {
			this.container.classList.remove('d-none');
			this.container.style.display = 'block';
			this.container.style.opacity = '1';
		}
	}
}